import { Map } from "immutable";
import * as React from "react";
import 'intersection-observer';
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { toRelativeUrl } from "../../../../../helpers";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type FeaturedContentAttributes = {
  blockName: 'vidda/featured-content'
  image_position: 'left' | 'right'
  label?: string
  title: string
  intro: string
  image: WordPress.MediaResponse
  button?: ButtonData
}

export interface FeaturedContentInterface {
  blockName: 'vidda/featured-content'
  attrs: FeaturedContentAttributes
}

export type FeaturedContentBlockProps<customBlockData,extra_images> = FeaturedContentAttributes


export function FeaturedContentBlock<customBlockData, extra_images>(
  props: FeaturedContentBlockProps<customBlockData, extra_images>,
  options?: { key?: string}
): (
  s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <section
          className={`block block--featured block--featured${props.image_position == "right" ? "-right" : "-left"}`}
        >
          <div className="block__inner container--2xl">
            <div className="block__content grid--block">
              {props.title && <h2 className="block__title typo--xl">{props.title}</h2>}
              {props.intro && <div className="block__intro text--styled" dangerouslySetInnerHTML={{__html: props.intro}}></div>}
              {props.button && (
                <footer className="block__footer">
                  {link(linkWrapper({title:props.button.text,url:props.button.url}),
                    {classname: "button button--primary--inverted"},
                    props.button.text,
                    () => {
                      window.dataLayer.push({
                        event: 'event.dubbeldam',
                        category: 'FeaturedContentBlock',
                        action: props.button.text,
                        label: window.location.pathname,
                      })
                    }
                  )}
                </footer>
              )}
            </div>
            {props.image && props.image.media_details && (
              <div className="block__visual">
                <img
                  src={getImageAttribute(props.image, 'square', 'source_url')}
                  width={getImageAttribute(props.image, 'square', 'width')}
                  height={getImageAttribute(props.image, 'square', 'height')}
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                />
              </div>
            )}
          </div>
        </section>
      )
    });
  };
}

